import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import get from 'lodash/get';
import React, { Component } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import * as ApiActions from 'actions/api';
import progress from 'utils/progress';
import 'styles/invite-form.scss';
const messages = defineMessages({
    placeholder: 'E-mail',
    action: 'Send',
    resend: 'Send again',
});
function isValidEmail(email) {
    return email && /.+@.+\..{2,}/i.test(email);
}
const mapStateToProps = createStructuredSelector({
    location: (state) => state.location,
});
class InviteForm extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            email: '',
        };
        this._handleSendAgain = () => {
            this.setState({
                sent: false,
                email: '',
            });
        };
        this._handleSubmit = (event) => {
            event.preventDefault();
            const params = {
                email: this.state.email,
            };
            if (this.props.type) {
                params.type = this.props.type;
            }
            const referer = get(this.props.location, 'query.referer');
            if (referer) {
                params.referer = referer;
            }
            progress.wrap(this.props.createInviteRequest(params).then(this._handleComplete));
        };
        this._handleChange = (event) => {
            this.setState({
                email: event.target.value,
            });
        };
        this._handleComplete = () => {
            this.setState({
                sent: true,
            });
        };
    }
    render() {
        return (_jsxs("form", { className: classnames('invite-form', this.props.className), onSubmit: this._handleSubmit, children: [_jsx("p", { children: this.state.sent ? this.props.success : this.props.title }), this.state.sent ? (_jsx("p", { children: _jsx("span", { className: "invite-form__again", onClick: this._handleSendAgain, children: _jsx(FormattedMessage, Object.assign({}, messages.resend)) }) })) : null, !this.state.sent ? (_jsxs("div", { className: "invite-form__content", children: [_jsx(FormattedMessage, Object.assign({}, messages.placeholder, { children: (placeholder) => (_jsx("input", { type: "email", placeholder: placeholder, value: this.state.email, onChange: this._handleChange })) })), _jsx("button", { disabled: !this._validate(), className: "button button--primary", children: _jsx(FormattedMessage, Object.assign({}, messages.action)) })] })) : null] }));
    }
    _validate() {
        return isValidEmail(this.state.email);
    }
}
export default connect(mapStateToProps, ApiActions)(InviteForm);
